import React, {useEffect} from 'react';
import Router, {useRouter} from 'next/router';
import AppLoader from '../../core/AppLoader';
import {useAuthMethod, useAuthUser} from '../../utility/AuthHooks';
import {useSelector, useDispatch} from 'react-redux';
import useSession from '@common/utility/hooks/useSession';
import StaffGuard from 'guards/StaffGuard';
import {toggleNavCollapsedHide} from 'redux/actions';

const withData = (ComposedComponent) => (props) => {
  const dispatch = useDispatch();
  const {isLoading} = useAuthUser();
  const {asPath} = useRouter();
  const queryParams = asPath.split('?')[1];
  const {isAuthenticated, accessToken, user, rememberMe} = useSelector(
    ({authentication}) => authentication,
  );
  const [value] = useSession('rememberMe');
  const {logout} = useAuthMethod();
  useEffect(() => {
    dispatch(toggleNavCollapsedHide());
    if (
      (!user && !isLoading) ||
      !accessToken ||
      !isAuthenticated ||
      (value === undefined && (rememberMe === false || rememberMe === null))
    ) {
      logout();
      Router.push('/dang-nhap' + (queryParams ? '?' + queryParams : ''));
    }
  }, [user, isLoading, isAuthenticated, accessToken]);
  if (!user || isLoading || !accessToken || !isAuthenticated)
    return <AppLoader />;

  return (
    <StaffGuard>
      <ComposedComponent {...props} />
    </StaffGuard>
  );
};
export default withData;
